import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { map, Observable } from 'rxjs';

import { GroupedServices } from '@fcom/dapi';
import { ButtonSize, ButtonTheme, IconPosition } from '@fcom/ui-components';
import { Category } from '@fcom/dapi/api/models';
import { MultivariateTestService } from '@fcom/common/multivariate-test/services/multivariate-test.service';
import { finShare } from '@fcom/rx';
import { MultivariateTestId, TestVariant } from '@fcom/common/interfaces';

import { ExtendedService } from '../../interfaces';

@Component({
  selector: 'fin-ancillary-selection',
  styleUrls: ['./ancillary-selection.component.scss'],
  templateUrl: 'ancillary-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AncillarySelectionComponent implements OnInit, OnChanges {
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly Category = Category;

  @Input()
  showRemove = true;
  @Input()
  ancillaries: ExtendedService[] = [];
  @Input()
  groupedServices: GroupedServices[] = [];
  @Input()
  hideSelection = false;
  @Input()
  isHighlightedServicesAvailable = false;

  @Output()
  removeSelections: EventEmitter<Event> = new EventEmitter();

  showRemoveBasedOnAncillaries: boolean;
  filteredGroupedServices: GroupedServices[];
  isHighlightedServicesTest$: Observable<boolean>;

  constructor(private multivariateTestService: MultivariateTestService) {}

  ngOnInit(): void {
    this.showRemoveBasedOnAncillaries = this.showRemoveButton();
    this.filteredGroupedServices = this.getFilteredGroupedServices();
    this.isHighlightedServicesTest$ = this.multivariateTestService
      .getTestVariant(MultivariateTestId.HIGHLIGHTED_SERVICES)
      .pipe(
        map(({ variant }) => variant === TestVariant.B),
        finShare()
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['showRemove']?.firstChange || !changes['ancillaries']?.firstChange) {
      this.showRemoveBasedOnAncillaries = this.showRemoveButton();
    }

    if (!changes['groupedServices']?.firstChange) {
      this.filteredGroupedServices = this.getFilteredGroupedServices();
    }
  }

  private getFilteredGroupedServices(): GroupedServices[] {
    return this.groupedServices.filter(({ key }) => key !== 'pendingPayment');
  }

  private showRemoveButton(): boolean {
    return (
      this.showRemove &&
      this.ancillaries.every(
        (ancillary) =>
          ancillary.paidQuantity === 0 || +ancillary.totalPrice?.amount === 0 || ancillary.isModifiable === true
      )
    );
  }
}
